<template>
    <v-card class="mx-auto pa-2"
            outlined
            style="margin-top: 0px; background-color: unset">

        <v-row>
            <v-col cols="12" md="2" class="d-flex" style="text-align: right">
                <v-menu
                    v-model="filterForm.openMenu"
                    offset-y
                    bottom
                    content-class="no-contain overflow-visible menu-filter-form-allotment"
                    :close-on-content-click="false"
                >
                    <template v-slot:activator="{ on }">
                    <v-btn style="margin-right: 10px;" class="mb-2" color="rgba(43, 1, 132, 0.5)" dark v-on="on">
                        <span>Tìm kiếm</span>
                        <v-icon style="margin-left: 10px; margin-right: -20px;">mdi-chevron-down</v-icon>
                    </v-btn>
                    </template>
                    <card-filter-form
                        :filterForm="filterForm"
                        :listType="listType"
                        :listSchoolLevel="listSchoolLevel"
                        :allotmentList="allotmentList"
                    />
                </v-menu>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import CardFilterForm from './CardFilterForm'
export default {
    components: {
      CardFilterForm
    },
    props: {
      listType: {
        type: Array,
        default: () => []
      },
      listSchoolLevel: {
        type: Array,
        default: () => []
      },
      filterForm: {
        type: Object,
        default: () => {}
      },
      allotmentList: {
        type: Array,
        default: () => {[]}
      },
    },
    methods: {

    }
}
</script>
<style scoped lang="css">
.menu-filter-form-allotment {
  background: white;
}
</style>